import MomentTimezone from 'moment-timezone';
export const convertToHumanRelativeTime = (absoluteTime) => {
    const absoluteTimeWithoutZ = absoluteTime.replace('Z', '');
    const absoluteTimeWithoutT = absoluteTimeWithoutZ.replace('T', ' ');
    return new Date(absoluteTimeWithoutT).toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
    });
};
export const convertMinutesToAbsoluteTime = (minutes) => {
    return MomentTimezone('2015-11-30T00:00:00Z')
        .startOf('day')
        .minutes(minutes)
        .format('YYYY-MM-DD[T]HH:mm:ss[Z]');
};
export const convertToTotalMinutesIntoDay = (absoluteTime) => {
    return (new Date(absoluteTime).getUTCHours() * 60 +
        new Date(absoluteTime).getUTCMinutes());
};
